import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setColumns } from '../store/actions/session';
import { companyInformationMappings } from './company_constants';
import ColumnSelector from 'components/table_header/column_selector';

export class CompanyColumnSelector extends React.Component {

  static propTypes = {
    currentColumns: PropTypes.array.isRequired,
    onCancelColumns: PropTypes.func.isRequired,
    onSetColumns: PropTypes.func.isRequired
  };

  render() {
    return (
      <ColumnSelector
        {...this.props}
        defaultColumns={[]}
        informationMappings={companyInformationMappings}
      />
    );
  }
}

const mapStateToProps = state => ({
  currentColumns: state.session.currentColumns
});

const mapDispatchToProps = {
  onSetColumns: setColumns
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyColumnSelector);